type TSocialItemProps = {
  title: string;
  icon: string;
  route: string;
};

const SocialItem = ({title, icon, route}: TSocialItemProps) => {
  return (
    <>
      <div className="rounded-full border-[1px] border-gray-600 p-1">
        <a
          href={route}
          className="no-underline text-gray-600 w-full h-full flex items-center justify-center active:text-gray-600 visited:text-gray-600"
        >
          <i className={icon}></i>
        </a>
      </div>
    </>
  );
};

export default SocialItem;
